/**
 * We can authenticate to the Application in two different ways, providing
 * great Business to Business and Business to Customer experiences:
 *
 * - entra: Authentication via Microsoft Entra,
 * meaning a login via a company Microsoft-Account.
 * This needs some setup on our side and is great for larger Customers.
 * - B2C: Authentication via Email and Password. Perfect for the typical small customer.
 * Can be invited via their BOAdmin/Kundenadmin.
 *
 * Both Authentication methods are handled by Azure, meaning we don't implement them here,
 * we just redirect to the corresponding tenant and then acquire a token afterwards.
 */
import { AUTH_IFRAME_HASH_TIMEOUT } from '@/constants';
import { FIVE_MINUTES_IN_SECONDS } from '@/constants';
import { getEnv } from '@/utils/envUtils';
import { BrowserCacheLocation, type Configuration } from '@azure/msal-browser';

const getVariables = () => ({
    clientId: getEnv()?.VITE_AUTH_ENTRA_AZURE_CLIENT_ID || '',
    tenantId: getEnv()?.VITE_AUTH_ENTRA_AZURE_TENANT_ID || '',
    scopes: [getEnv()?.VITE_AUTH_ENTRA_AUTHORITY_SCOPE || ''],
    authority: getEnv()?.VITE_AUTH_ENTRA_AUTHORITY_DOMAIN || '',
    redirectUri: getEnv()?.VITE_AZURE_REDIRECT_URI || '',
});

export const getConfig = () => {
    const { clientId, tenantId, scopes, authority, redirectUri } = getVariables();
    const msalConfig: Configuration = {
        auth: {
            clientId,
            authority,
            redirectUri,
            knownAuthorities: [authority],
            postLogoutRedirectUri: `${location.origin}/`,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
            cacheRetentionDays: 1,
        },
        system: {
            iframeBridgeTimeout: AUTH_IFRAME_HASH_TIMEOUT,
            redirectNavigationTimeout: AUTH_IFRAME_HASH_TIMEOUT,
            nativeBrokerHandshakeTimeout: AUTH_IFRAME_HASH_TIMEOUT,
            tokenRenewalOffsetSeconds: FIVE_MINUTES_IN_SECONDS,
            allowRedirectInIframe: false,
        },
    };
    return {
        msalConfig,
        scopes,
        tenantId,
    };
};
